import { render } from "./UltimateService.vue?vue&type=template&id=fcd5ba86"
import script from "./UltimateService.vue?vue&type=script&lang=js"
export * from "./UltimateService.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__